/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTokenUserNestedExternalSystem
 */
export interface UserTokenUserNestedExternalSystem {
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNestedExternalSystem
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedExternalSystem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedExternalSystem
     */
    label: string;
}

export function UserTokenUserNestedExternalSystemFromJSON(json: any): UserTokenUserNestedExternalSystem {
    return UserTokenUserNestedExternalSystemFromJSONTyped(json, false);
}

export function UserTokenUserNestedExternalSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokenUserNestedExternalSystem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': json['label'],
    };
}

export function UserTokenUserNestedExternalSystemToJSON(value?: UserTokenUserNestedExternalSystem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
    };
}


